import { useDispatch, useSelector } from 'react-redux'

export default function useFilter (key = '') {
    const dispatch = useDispatch()
    const leadInfo = useSelector(state => state.leadInfo[key])
    const allLeadInfos = useSelector(state => state.leadInfo)

    const setLeadInfo = value => {
        dispatch({
            type: '@leadInfo/SET',
            key,
            value
        })
    }

    const resetAllLeadInfos = () => {
        dispatch({
            type: '@leadInfo/RESET'
        })
    }

    return {
        setLeadInfo,
        resetAllLeadInfos,
        leadInfo,
        allLeadInfos,
    }
}
